<template>
    <div class="skill_link_list">
        <!--<router-link to="/position_target" tag="a" id="skill_to_outline_button">-->
            <!--<button :class="!data['is_eval'] && link_state === 'common'?'re_score':'not_show'">目标规划</button>-->
        <!--</router-link>-->
        <router-link to="/skill/self_score" tag="a" id="self_score_button">
            <button :class="data['is_eval']?'not_show':'re_score'">重新评估</button>
        </router-link>
        <router-link to="/eval_position" tag="a" id="re_eval_button">
            <button :class="data['is_eval']?'re_score':'not_show'">重新评估</button>
        </router-link>
        <router-link to="/position_target" tag="a" id="position_to_target_button">
            <button :class="data['is_eval'] && link_state === ''?'to_target':'not_show'">职业发展规划</button>
        </router-link>
        <router-link to="/skill/skill_target" tag="a" id="skill_to_target_button">
            <button :class="!data['is_eval'] && link_state === 'hr'?'to_target':'not_show'">专业技能规划</button>
        </router-link>
        <router-link to="/skill/skill_target" tag="a" id="skill_to_target_common_button">
            <button :class="!data['is_eval'] && link_state === 'common'?'to_target':'not_show'">通用技能规划</button>
        </router-link>
        <router-link to="/eval_position" tag="a" id="re_eval_button_2">
            <button :class="data['is_eval']?'not_show':'to_other_eval'">职业发展评估</button>
        </router-link>
        <router-link to="/skill/self_score/hr" tag="a" id="skill_hr_button">
            <button :class="data['is_eval'] || link_state === 'common'?'to_other_eval':'not_show'">专业技能评估</button>
        </router-link>
        <router-link to="/skill/self_score/common" tag="a" id="skill_common_button">
            <button :class="data['is_eval'] || link_state === 'hr'?'to_other_eval':'not_show'">通用技能评估</button>
        </router-link>
        <router-link to="/skill/skill_submit" tag="a" id="skill_submit_button">
            <button :class="data['is_eval']?'not_show':'to_submit'">提交资料</button>
        </router-link>

        <!--<router-link to="/outline" tag="a" id="eval_button">-->
            <!--<button :class="data['is_eval']?'re_score':'not_show'">目标规划</button>-->
        <!--</router-link>-->


        <!--<router-link to="/goal" tag="a" id="eval_result_button">-->
            <!--<button :class="!data['is_eval'] && link_state === 'common'?'re_score':'not_show'">目标规划</button>-->
        <!--</router-link>-->

    </div>
</template>
<script type="text/javascript">

import { mapState, mapActions  } from 'vuex'

export default {
    props: {
        data: {
            type: Object,
            require: true
        }
    },
    data: function () {
        return {
            link_state: '',
        }
    },
    methods: {
        ...mapActions({

        })
    },
    computed: {
        ...mapState({

        })
    },
    mounted: function () {
        this.link_state = localStorage.getItem('field')
        console.log(localStorage.getItem('field'))
    }
}

</script>
<style type="text/css">
.skill_link_list {
    background: #fff;
    display: -o-flex;
}
.skill_state_part {
    width: 33%;
    padding: 10px 15px;
    font-size: 16px;
    color: #565656;
    max-height: 45px;
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
}
.re_score{
    padding: .375rem .5rem;
    color: #fff;
    margin: 10px;
    background: #6699CC;
    border: 1px solid #6699CC;
    width: 200px;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.to_target{
    padding: .375rem .5rem;
    color: #fff;
    margin: 10px;
    background: #333366;
    border: 1px solid #333366;
    width: 200px;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.to_other_eval{
    padding: .375rem .5rem;
    color: #fff;
    margin: 10px;
    background: #99CC33;
    border: 1px solid #99CC33;
    width: 200px;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.to_submit{
    padding: .375rem .5rem;
    color: #fff;
    margin: 10px;
    background: #999999;
    border: 1px solid #999999;
    width: 200px;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.not_show{
    display: none;
}

</style>
